module.exports = __webpack_public_path__ + "static/14-c0f3c0cb8fc6064bf9ef22aa09f23bef.jpg";